import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLayout from '@/components/layout/AdminLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'AdminLogin',
    component: () => import('@/views/AdminLogin.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    component: AdminLayout,
    redirect: '/dashboard',
    meta: { role: 'admin' },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '账户总览', role: 'admin' }
      },
      {
        path: 'orders',
        name: 'AdminOrders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '订单管理', role: 'admin' }
      },
      {
        path: 'withdraw',
        name: 'AdminWithdraw',
        component: () => import('@/views/AdminWithdraw.vue'),
        meta: { title: '提现审核', role: 'admin' }
      },
      {
        path: 'withdraw-fees',
        name: 'AdminWithdrawFees',
        component: () => import('@/views/AdminWithdrawFee.vue'),
        meta: { title: '提现手续费', role: 'admin' }
      },
      {
        path: 'merchants',
        name: 'AdminMerchants',
        component: () => import('@/views/Merchants.vue'),
        meta: { title: '商户管理', role: 'admin' }
      },
      {
        path: 'merchants/:id',
        name: 'AdminMerchantDetail',
        component: () => import('@/views/MerchantDetail.vue'),
        meta: { title: '商户详情', role: 'admin' }
      }
    ]
  },
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((r) => r.meta.public)
  if (isPublic) {
    next()
    return
  }
  const token = sessionStorage.getItem('cryptopay_admin_token')
  if (!token) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
